import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CustomCookieService } from 'src/app/shared/services/custom-cookie.service';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { camelCase, mapKeys, set, template } from 'lodash';
import { switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  templateUrl: './universal-error.component.html',
  styleUrls: ['./universal-error.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class UniversalErrorComponent implements OnInit {
  public data: any;
  public buttons: string[];
  public urlParams: object;
  constructor(
    private route:ActivatedRoute,
    private customCookieService: CustomCookieService,
    private helpersService: HelpersService,
    private router: Router,
    private http: HttpClient
    ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.urlParams = params; // Use the parameter name defined in your routes
    });
    this.route.data.subscribe((data: any)=> {
      this._handleCookiesPlaceholders(data);
    });
  }

  public onBackClick() {
    this.helpersService.navigateBackToOEM(this.data.code);
  }

  public onBackToSelectPlans() {
    const mdn = this.customCookieService.getData('ui-selectedMdn', true);
    console.log('mdn', mdn)
    this.router.navigate(['account/select-plan'], {
      queryParams: {mdn}
    });
  }

  private async _handleCookiesPlaceholders(data: any) {
    const cookies = mapKeys(this.customCookieService.getAll() || {}, (value,key) => camelCase(key))
    const _formatPhoneNumber = (value: string | number): string => {
      const cleaned = ('' + value).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
      return value.toString();
    }
    const _getValue = (rawString: string): string => {
      const dataSrc: any = Object.assign({}, cookies, this.urlParams)
      if (dataSrc.mdn) {
        dataSrc.mdn = _formatPhoneNumber(dataSrc.mdn)
      }
      try {
        return template(rawString)(dataSrc)
      } catch (err) {
        return rawString;
      }
    }
    this.data = data;
    set(this.data,'title', _getValue(data.title))
    set(this.data,'description', _getValue(data.description))
  }

  
}
